import React from "react";
import Reviews from "../../sections/Reviews/Reviews";
import "./ProductReviews.css";

function ProductReviews() {
  return (
    <main className="ProductReviews">
      <Reviews />
    </main>
  );
}

export default ProductReviews;
